import calculateNodeScore from './calculateNodeScore';
import queryNode from './queryNode';
import createNode from './createNode';

function getReference(_ref) {
  var type = _ref.type,
      _ref$media = _ref.media,
      media = _ref$media === undefined ? '' : _ref$media,
      _ref$support = _ref.support,
      support = _ref$support === undefined ? '' : _ref$support;

  return type + media + support;
}

export default function getNodeFromCache(attributes, renderer) {
  var targetDocument = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

  var reference = getReference(attributes);

  if (!renderer.nodes[reference]) {
    var score = calculateNodeScore(attributes, renderer.mediaQueryOrder);
    var node = queryNode(attributes, targetDocument) || createNode(renderer.nodes, score, attributes, targetDocument);

    renderer.nodes[reference] = {
      node: node,
      score: score
    };
  }

  return renderer.nodes[reference].node;
}